import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import Fuse from 'fuse.js';

import CamdetectMessagesTable from '../components/CamdetectMessagesTable';
import CamdetectMessagesModel from '../components/CamdetectMessagesModel';
import CamdetectCamerasSelect from '../components/CamdetectCamerasSelect';

import { Layout, Button, Row, Col, Input, Icon, DatePicker, message } from 'antd';

class CamdetectMessagesScreen extends Component {

    fuseOptions = {
        shouldSort: true,
        includeScore: true,
        threshold: 0.1,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 2,
        keys: [
            "placeID"
        ]
    }

    state = {
        dataLoading: false,
        dataAll: [],
        data: [],
        parkinglocationPlacesFormModalVisible: false,
        camera: null,
        date: null,
        dateFrom: moment().startOf('day'),
        dateTo: moment().endOf('day')
    }
    onDateRangeChanged(dates, dateStrings) {
        this.setState({
            dateFrom: dates[0],
            dateTo: dates[1]
        });
        this.loadData(this.state.camera, dates[0], dates[1]);
    }

    loadData(camera, dateFrom = null, dateTo = null) {
        dateFrom = dateFrom ? dateFrom.format() : null;
        dateTo = dateTo ? dateTo.format() : null;
        if (camera) {
            this.setState({
                dataLoading: true
            });
            CamdetectMessagesModel.getAll(camera, dateFrom, dateTo)
                .then(data => {
                    this.setState({
                        dataLoading: false,
                        dataAll: data,
                        data: data,
                    });
                })
                .catch(err => {
                    message.warning('Historie obsazenosti se nepodařila načíst!');
                    this.setState({
                        dataLoading: false,
                    });
                });
        } else {
            message.warning('Zvolte prosím kameru!');
        }
    }

    render() {
        return (
            <Layout.Content style={{ margin: '24px 16px 0', minHeight: 'auto' }}>
                <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
                    <h2>Kamerová detekce - Historie obsazenosti</h2>
                    <div style={{ marginBottom: '20px' }}>
                        <Row>
                            <Col span={20}>
                                <CamdetectCamerasSelect
                                    onChange={(value) => {
                                        this.setState({ camera: value });
                                        this.loadData(value, this.state.dateFrom, this.state.dateTo);
                                    }}
                                    style={{ width: 300 }} />
                                {' '}
                                <DatePicker.RangePicker
                                    defaultValue={[
                                        this.state.dateFrom,
                                        this.state.dateTo
                                    ]}
                                    ranges={{
                                        "Dnes": [moment().startOf('day'), moment().endOf('day')],
                                        "Včera": [moment().add(-1, 'days').startOf('day'), moment().add(-1, 'days').endOf('day')],
                                        "Poslední týden": [moment().add(-7, 'days').startOf('day'), moment().endOf('day')],
                                    }}
                                    allowClear={false}
                                    placeholder={['Od', 'Do']}
                                    format="DD.MM.YYYY HH:mm"
                                    showTime={{ format: 'HH:mm' }}
                                    onOk={this.onDateRangeChanged.bind(this)}
                                    style={{ width: 300 }} />
                            </Col>
                            <Col span={4} offset={0} style={{ textAlign: 'right' }}>
                                <Button type="default" onClick={() => { this.loadData(this.state.camera, this.state.dateFrom, this.state.dateTo) }} style={{ marginRight: 10 }}>
                                    <Icon type="sync" />
                                </Button>
                            </Col>
                        </Row>
                    </div>
                    <CamdetectMessagesTable
                        data={this.state.data}
                        loading={this.state.dataLoading}
                    />
                </div>
            </Layout.Content>
        );
    }
}

export default CamdetectMessagesScreen;



// WEBPACK FOOTER //
// ./src/screens/CamdetectMessagesScreen.js